import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import * as playerActions from "../../actions/playerActions";

import List from "./List";

class PanelsView extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {			
		};
	}

	componentDidMount() {
		window.addEventListener("resize", _.debounce(this.onResize, 50));
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", _.debounce(this.onResize, 50));
	}

	handleListExpandAll(listIndex) {
		this.props.dispatch(
			playerActions.listExpandAll,
			listIndex
		);
	}

	handleListCollapseAll(listIndex) {
		this.props.dispatch(
			playerActions.listCollapseAll,
			listIndex
		);
	}

	onResize() {
		//// console.log("resize window!");
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	render() {

		let self = this;

		let lists;
		//this is for the case where an admin might be editing an existing checklist
		//let identityId = "test-identity-id";
		let listCount = 0;
		let sectionCount = 0;

		self.props.activity.children.forEach(list => {
			listCount++;
			sectionCount += list.children ? list.children.length : 0;
		});

		let defaultExpanded = (listCount === 1 || sectionCount === 1) ? true : false;

		try {
			if (self.props.activity && self.props.activity.children) {
				lists = self.props.activity.children.map((list, i) => {
					let listComponent = <List activity={this.props.activity} list={list} listIndex={i} defaultExpanded={defaultExpanded} />;
					return listComponent;
				});
			}
		} catch (e) {
			console.error(e);
			alert(e.message);
			lists =
				<div>There was an error getting the content for the activity!</div>;
		}
		
		// onScroll={this.handleScroll}
		let listsView = <div className="top-list-view" style={{ maxWidth: this.props.defaultColumnWidth, width: "100%", marginLeft: "auto", marginRight: "auto" }}>
			<div style={{ height: this.state.paddingHeight ? this.state.paddingHeight - 100 : "auto" }} />
			<div>{lists}</div>
			<div style={{ height: this.state.paddingHeight ? this.state.paddingHeight + 50 : "auto" }} />
		</div>;

		return listsView;
	}
}

PanelsView.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	activityTheme: ["activity", "theme"],
	user: ["user"],
	defaultColumnWidth: ["appPreferences", "defaultColumnWidth"]
}, PanelsView);